import React, { useEffect, useState } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css'; // This theme has a black background
import 'prismjs/components/prism-bash'; // For Bash syntax highlighting
import { CopyToClipboard } from 'react-copy-to-clipboard';

const CodeSnippet = () => {
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		Prism.highlightAll();
	}, []);

	useEffect(() => {
		if (copied) {
			const timer = setTimeout(() => {
				setCopied(false);
			}, 5000);
			return () => clearTimeout(timer); // Cleanup the timer
		}
	}, [copied]);

	const code = `
  curl -X 'POST' \\
    'https://api.maytapi.com/api/{product_id}/{phone_id}/sendMessage' \\
    -H 'accept: application/json' \\
    -H 'x-maytapi-key: {token}' \\
    -H 'Content-Type: application/json' \\
    -d '{
    "to_number": "905301234567@c.us",
    "type": "vcard",
    "message": {
      "displayName": "John Doe",
      "vcard": "BEGIN:VCARD\\nVERSION:3.0\\nFN;CHARSET=UTF-8:John Doe\\nN;CHARSET=UTF-8:;John;Doe;;\\nTEL;TYPE=CELL:+9051234567\\nREV:2020-01-23T11:09:14.782Z\\nEND:VCARD"
    }
  }'
  `;

	return (
		<div style={{ position: 'relative' }}>
			<CopyToClipboard text={code} onCopy={() => setCopied(true)}>
				<button
					style={{
						position: 'absolute',
						top: 10,
						right: 10,
						padding: '5px 10px',
						backgroundColor: '#4CAF50',
						color: 'white',
						border: 'none',
						borderRadius: '3px',
						cursor: 'pointer',
					}}
				>
					{copied ? 'Copied!' : 'Copy'}
				</button>
			</CopyToClipboard>
			<pre>
				<code className="language-bash" style={{ padding: '0!important' }}>
					{code}
				</code>
			</pre>
		</div>
	);
};

export default CodeSnippet;
